<template>

    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="status"
            v-bind:substatus.sync="substatus"
        >
        </FilterPanel>

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Documents.NPA.Document', common: true })"
                    >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.createdate`]="{ item }">
                        <div>{{dateFormat(item.createdate, 'DD.MM.YYYY')}}</div>
                    </template>

                    <template v-slot:[`item.regdate`]="{ item }">
                        <div>{{dateFormat(item.regdate, 'DD.MM.YYYY')}}</div>
                    </template>

                    <template v-slot:[`item.theme`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <v-doc-type-chip :type="item.doctypeof" :text="item.doctype" />
                            
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.theme">
                                    {{ item.theme }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.draftstatus`]="{ item }">
                        <StatusChip v-if="category == -1" :status="avaibleStatuses[$helpers.getDraftStatus(item.draftstatus)]"/>
                        <NPATypeChip v-else :is-project="category === '-1'" :type="item.npatype" :changed="item.haschange" :terminationDate="item.srok" />
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>

        </v-row>

    </div>

</template>

<script>
import i18n from '@/i18n'
import { httpAPI } from "@/api/httpAPI";
import { mapActions } from 'vuex';
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';
import _ from 'lodash';
import sys from '@/services/system';
import NPATypeChip from '@/components/global/chips/NPATypeChip.vue';
import StatusChip from '@/components/global/chips/StatusChip';

export default {
    name: "NPALists",
    columnIndex: {
        'regnumber': 5,
        'regdate': 6,  
        'createdate': 3,
        'theme': 4,        
    },
    components: {
        Toolbar,
        FilterPanel,
        NPATypeChip,
        StatusChip,
        SearchPanel
    },
    data() {
        return {
            cancellationTokenSorce: null,
            loading: true,
            total: 0,
            entities: [],
            dataSource: null,
            filterDataSource: null,
            paginationPageCount: 0,
        }
    },
    computed : {
        headers() {
            let h = [];
            h.push({ text: i18n.t("Рег._№"), value: 'regnumber', width: '150px' });

            if (this.category == '-1')
                h.push({ text: i18n.t("Дата_создания"), value: 'createdate', width: '130px' });
            else 
                h.push({ text: i18n.t("Рег._дата"), value: 'regdate', width: '110px' });

            h.push({ text: i18n.t("Краткое_содержание"), value: 'theme'});

            if ((this.category == '-1' && this.status == '2') || this.category >=0 )
                h.push({ text: i18n.t("Статус"), value: 'draftstatus', width: '150px', sortable: false});

            return h;
        },
        options: {
            get: function() {
                return this.$store.getters['npa/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('npa/SET_TABLE_OPTION', newValue);
            }
        },
        category() {
            return this.$store.getters['npa/getCategory']
        },
        status: {
            get: function() {
                return this.$store.getters['npa/getStatus'];
            },
            set: function(newValue) {
                this.$store.commit('npa/SET_STATUS', newValue);
            }
        },
        substatus: {
            get: function() {
                return this.$store.getters['npa/getSubstatus'];
            },
            set: function(newValue) {
                this.$store.commit('npa/SET_SUBSTATUS', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['npa/getTableSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('npa/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('npa/SET_TABLE_SEARCH', v);
            }, 500)
        },
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                NPAYear: this.status,
                NPAType: this.category,
                NPAStatus: this.substatus
            }
        },
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        ...mapActions('npa', ['updateCounter']),
        onToolbarClick(event, btn) {
            this[btn.Action](btn);
        },
        async getData(isRefresh = false) {
            let newTableFilter = this.getTableFilterObject();

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, newTableFilter)) {
                return;
            }

            this.setOverlayVisible({ visible: true });

            this.prevTableFilterObject = newTableFilter;

            this.total = 0;
            this.loading = true;

            let filterResponse = await httpAPI({
                url: `api/npa/filter?category=${this.category}&year=${this.status}`,
                method: 'GET',
            });
            
            if (filterResponse) {
                var permissions = (this.$store.getters['global/auth/getUserInfo'])?.Permissions ?? [];
                filterResponse.data.Payload.Filter.Items = filterResponse.data.Payload.Filter.Items.filter(i => this.$_.difference(i.Requires, permissions).length === 0);
                filterResponse.data.Payload.Filter.Default = filterResponse.data.Payload.Filter.Items[0].Value;
                this.filterDataSource = filterResponse.data.Payload;
            }

            let response = await httpAPI({
                url: `api/npa/list?filter=${JSON.stringify(this.prevTableFilterObject)}`,
                method: 'GET',
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            
            this.loading = false;
            this.setOverlayVisible({ visible: false });

            this.updateCounter();
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, NPAYear, NPAType, NPAStatus } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "regdate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 4;

            return NPAType == "-1"
                ? { SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, MyDraftStatus: NPAYear, RegState: -1 }
                : { SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, NPAYear, NPAType, NPAStatus, RegState: 1 }; 
        },
        async Refresh() {
            await this.getData(true);
        },
        dateFormat(value, format, inputFormat) {
            return sys.dateFormat(value, format, inputFormat);
        },
    },
    watch: {
        filter: {
            handler () {
                this.getData();
            },
            deep: true,
        },
    },
    async created() {
        this.setOverlayVisible({ visible: true });

        let response = await httpAPI({
            url: `api/actions/collection?type=Documents.NPAApproved`,
            method: 'GET',
        });

        if (response)
            this.$store.commit('documents/toolbar/SET_MENU', { menu: response.data.Payload.Data.Menu });

        this.setOverlayVisible({ visible: false });
    },
}
</script>
